module.exports = __webpack_public_path__ + "static/AM Best-2a2d2ff4981974387dbf8bae8a1974c1.png";